import script from "./ArrowIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrowIcon.vue?vue&type=script&setup=true&lang=js"

import "./ArrowIcon.vue?vue&type=style&index=0&id=0729f19a&scoped=true&lang=css"

import exportComponent from "/builds/smartdevops/viccarbe/viccarbe-professional-area/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0729f19a"]])

export default __exports__